import { DocumentConnection } from '../../common/model/document-connection-base';
import { PropertyDocumentType, PropertyDocumentTypeToString } from './const/documentEnums';

export class PropertyDocument extends DocumentConnection<PropertyDocumentType> {
  constructor() {
    super();
  }

  get connectionTypeText(): string {
    return PropertyDocumentTypeToString(this.connectionType);
  }

  propertyId: string;

  toJSON() {
    const result = super.toJSON();
    result['propertyId'] = this.propertyId;
    return result;
  }
}
